<template>
  <div id="app">
    <HeadersP v-show="!isMobile"></HeadersP>
    <HeadersM v-show="isMobile"></HeadersM>
    <Navs v-show="!isMobile"></Navs>
    <div :class="{container:!isMobile}">
      <router-view v-if="isRouterAlive"/>
    </div>
    <FootersP v-show="!isMobile"></FootersP>
    <FootersM v-show="isMobile"></FootersM>
    <div id="top" class="go-top-box" v-show="!isMobile&&goTopShow">
      <div class="go-top" @click="goTop()">
        <i class="icon iconfont icon-huidingbudianji"></i>
      </div>
      <div class="qr-code">
        <i class="icon iconfont icon-qrcode"></i>
      </div>
    </div>
    <div class="go-top-box1" v-show="isMobile&&goTopShow" @click="goTop()">
      <i class="el-icon-arrow-up"></i>
    </div>
    <!-- 简介弹窗 -->
    <PopupP class="popup-pc" v-show="!isMobile&&pcPopupShow" :data="pcData" @pcPopupShow="getPcPopupShow"></PopupP>
    <PopupM class="popup-app" v-show="isMobile&&appPopupShow" :data="appData" @appPopupShow="getAppPopupShow"></PopupM>
  </div>
</template>

<script>
import HeadersP from './components/pc/common/headers/HeadersP.vue';
import FootersP from './components/pc/common/footers/FootersP.vue';
import HeadersM from './components/mobile/common/headers/HeadersM.vue';
import FootersM from './components/mobile/common/footers/FootersM.vue';
export default {
  name: 'App',
  components:{
    HeadersP,
    FootersP,
    HeadersM,
    FootersM
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isMobile: false,
      goTopShow: false,
      pcPopupShow: false,
      appPopupShow: false,
      pcData: {},
      appData: {}
    }
  },
  mounted() {
    // 获取设备类型
    this.getEquipment();
    // 监听页面滚动位置，显示返回顶部按钮
    this.listenGoTop();
    this.Bus.$on('pcPopupShow', msg => {
      // console.log('msg>>>', msg);
      this.pcPopupShow = msg.popupShow;
      this.pcData = {
        title: msg.title,
        data: msg.data
      };
    });
    this.Bus.$on('appPopupShow', msg => {
      // console.log('msg>>>', msg);
      this.appPopupShow = msg.popupShow;
      this.appData = {
        title: msg.title,
        data: msg.data,
        time: msg.time
      };
    });
  },
  methods: {
    // reload () {
    //   this.isRouterAlive = false;
    //   this.$nextTick(function() {
    //      this.isRouterAlive = true;
    //   })
    // }
    getEquipment() {
      let flag = window.localStorage.getItem("isMobile");
      if(flag == 'false' || flag == false) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
        this.setRemSize();
      }
    },
    setRemSize() {
      // 设计稿宽度414px
      let w = 414;
      // 根元素fontsize尺寸
      let html = document.documentElement;
      // let size = window.getComputedStyle(html).fontSize;
      // 获取屏幕宽度
      let scrWidth = document.documentElement.clientWidth;
      let rem = 100;
      // (当前设备屏幕宽度 / 设计稿宽度) * 当前1rem的取值
      html.style.fontSize = ((scrWidth / w) * rem) + 'px';
      let dpr = window.devicePixelRatio;
      html.setAttribute('data-dpr', dpr);
      html = null;
    },
    listenGoTop() {
      document.addEventListener('scroll', () => {
        if(document.documentElement.scrollTop >= 190 || document.body.scrollTop >= 190) {
          this.goTopShow = true;
        } else {
          this.goTopShow = false;
        }
      });
      window.onresize = function() {
        let cw = document.documentElement.clientWidth;
        if(cw <= 1475) {
          let r = 75 - (1475 - cw);
          if(r > 0) {
            document.getElementById('top').style.right = r + 'px';
          } else {
            document.getElementById('top').style.right = 0;
          }
        } else {
          document.getElementById('top').style.right = 75 + 'px'; 
        }
      }
    },
    goTop() {
      let count = 50;
      if(document.documentElement.scrollTop) {
        let timer = setInterval(() => {
          if(document.documentElement.scrollTop == 0) {
            clearInterval(timer);
          } else {
            document.documentElement.scrollTop -= count;
          }
        }, 0.1);
      } else {
        let timer = setInterval(() => {
          if(document.body.scrollTop == 0) {
            clearInterval(timer);
          } else {
            document.body.scrollTop -= count;
          }
        }, 0.1);
      }
    },
    getPcPopupShow(msg) {
      // console.log('msg111>>>', msg);
      this.pcPopupShow = msg;
    },
    getAppPopupShow(msg) {
      this.appPopupShow = msg;
    }
  }
}
</script>

<style>
#app {
  position: relative;
  font-family: Microsoft YaHei;
}
.container {
  min-height: 800px;
}
.go-top-box {
  position: fixed;
  right: 75px;
  bottom: 80px;
  width: 82px;
  height: 205px;
  z-index: 1000;
}
.go-top {
  width: 58px;
  height: 58px;
  margin: 34px auto;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
}
.go-top>i {
  font-size: 60px;
  color: #6C9BCC;
}
.qr-code {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  background: #6C9BCC;
  border-radius: 50%;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
}
.qr-code>i {
  font-size: 35px;
  color: #fff;
}
.popup-pc, .popup-app {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    transition: all .5s;
    z-index: 99;
}
.go-top-box1 {
  position: fixed;
  right: 0.035rem;
  bottom: 0.9rem;
  width: 0.495rem;
  height: 0.495rem;
  border-radius: 50%;
  background: #fff;
  box-shadow:0rem 0rem 0.06rem rgba(0,0,0,0.3);
  z-index: 9999;
}
.go-top-box1 > i {
  position: absolute;
  top: 0.1rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.28rem;
  font-weight: bold;
  color: #666;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue